import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useDeleteCodePipelineMutation} from '../hooks/useCodePipelinesQuery';
import {useCodePipelinesSelection} from "../hooks/useCodePipelinesSelection.ts";


export const DeleteRecordButton = () => {

    const deleteCodePipelineMutation = useDeleteCodePipelineMutation();

    const {
        selection,
        handleClearSelection,
    } = useCodePipelinesSelection();

    const recordIds = Object.keys(selection).filter(id => selection[id] === true);
    const disabled = recordIds.length === 0;

    const handleDelete = async () => {
        for (const name of recordIds) {
            await deleteCodePipelineMutation.mutateAsync(name);
        }
        handleClearSelection();
    };

    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={handleDelete}
    />);

};
